
const simpleCache = function () {
	let cache = {};
	return {
		clear: () => { cache = {}; },
		invalidate: key => { delete cache[ key ]; },
		set: ( key, valueGenerator, forceRecache = false ) => {
			if ( forceRecache || !cache[ key ] ) {
				cache[ key ] = valueGenerator();
			}
			return cache[ key ];
		},
	};
};

export const create = () => simpleCache();



// WEBPACK FOOTER //
// ./src/lib/simpleCache.js